import m from "mithril";
export default {
    view() {
        return (m("section", { class: "error-page" },
            m("div", { class: "alert alert--danger alert--icon mv3 pulse animated" },
                m("i", { class: "fas fa-exclamation-triangle" }),
                "Huch, bei der Abfrage einiger Daten ist wohl ein Fehler aufgetreten. Bitte versuchen Sie es sp\u00E4ter erneut.")));
    },
};
